import React, { useState, useRef, useEffect } from 'react';
import { Modal, Input, Form, Button, Table, Checkbox, InputNumber } from 'antd';
import Moment from 'moment';
import API from '../../../services/API';

export default function PatchStatementModal({ furnishingAccount, creditCardTransactions, creditCard, refresh }) {

  const formRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalLoading, showModalLoading] = useState(false);
  const [voidedAmount, setVoidedAmount] = useState(0);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [amountValues, setAmountValues] = useState({});
  const creditCardResponse = creditCardTransactions?.length > 0 ? creditCardTransactions[0] : {};
  const {
    accountDetails,
    creditCardTransactions: transactionDetails
  } = creditCardResponse;
  const {
    accountId
  } = furnishingAccount;
  console.log('creditCardTransactions', creditCardTransactions, 'furnishingAccount', furnishingAccount, 'creditCard', creditCard)

  const supportId = '';
  const notes = '';
  const labelCol = {span: 12};

  const showModal = () => {
    setIsModalOpen(true);
  };

  const patchStatement = (data) => {
    console.log('patchStatement', data);
    showModalLoading(true);

    const {
      isFraud,
      supportId,
      notes
    } = data;

    const requestData = {
      accountId,
      isFraudRelated: isFraud,
      zendeskTicketNum: supportId,
      deleteNote: notes
    };

    let request;
    if (creditCard) {
      requestData.transactionsToVoid = selectedKeys.map((key) => {
        return {
          transactionId: key,
          voidedAmountInCents: [] // amountValues[key] ?? transactions.filter((row) => row.transactionId === key)[0].amountInCents
        }
      });
      request = API.deleteRevolvingFurnishingAccount(requestData);
    } else {
      request = API.deleteInstallmentFurnishingAccount(requestData);
    }

    request.then((resp) => {
      showModalLoading(false);
      setIsModalOpen(false);
      alert(resp?.message || 'Successfully deleted')
      if (refresh) refresh();
    }).catch((error) => {
      alert(error?.message || 'Something went wrong')
      showModalLoading(false);
    });
  };

  const cancelPatch = () => {
    formRef.current?.resetFields();
    setIsModalOpen(false);
  };

  const onFinish = (data) => {
    patchStatement(data);
  };

  const handleAmountChange = (record, val) => {
    const newAmountValues = { ...amountValues };
    newAmountValues[record.key] = val;
    setAmountValues(newAmountValues);
  }

  useEffect(() => {
    let voidedCalculated = 0;
    selectedKeys.map((key) => {
      voidedCalculated += amountValues[key] ?? transactions.filter((row) => row.transactionId === key)[0].amountInCents ?? 0;
    });
    setVoidedAmount(voidedCalculated);
    
  }, [selectedKeys, amountValues, transactions]);

  useEffect(() => {

    if (transactionDetails?.length > 0) {
      setTransactions(transactionDetails.filter((row) => row.status === 'SETTLED' && row.transactionType === 'CREDIT'));
    }

  }, [transactionDetails]);

  const onFinishFailed = (error) => {
    console.log('new error', { ... error});
  };

  const data = transactions.map((transaction) => {
    return {
      key: transaction.transactionId,
      id: transaction.transactionId,
      amountInCents: transaction.amountInCents,
      amount: transaction.amount,
      date: Moment(transaction.transactionDate).format('MM-DD-YYYY'),
      descriptor: transaction.descriptor,
    };
  });

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, selectedRowKeys, 'selectedRows: ', selectedRows, formRef.current);
      setSelectedKeys(selectedRowKeys);
    },
    getCheckboxProps: (record) => ({
      disabled: selectedKeys.indexOf(record.key) === -1 && accountDetails?.paymentDueInCents === voidedAmount,
      // Column configuration not to be checked
      name: record.key,
    }),
  };

  return (
    <>
      <Button type="danger" onClick={showModal} style={{ marginLeft: "auto" }} block>
        Delete Tradeline
      </Button>
      <Modal title={"Delete Tradeline: "} open={isModalOpen} footer={null} onCancel={() => setIsModalOpen(false)}>
      <Form
        name="basic"
        labelCol={{
          span: 8,
        }}
        wrapperCol={{
          span: 16,
        }}
        style={{
          maxWidth: 600,
        }}
        initialValues={{
            supportId,
            notes,
        }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
        ref={formRef}
      >
          <div>
            <Form.Item
              label="Is Fraud?"
              labelCol={labelCol}
              name="isFraud"
              valuePropName="checked"
            >
              <Checkbox />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label="Support Ticket Number"
              labelCol={labelCol}
              name="supportId"
              rules={[
                {
                  required: true,
                  message: 'Please input Support Ticket Number',
                },
              ]}
            >
              <Input />
            </Form.Item>
          </div>
          <div>
            <Form.Item
              label="Notes"
              labelCol={labelCol}
              name="notes"
              rules={[
                /*{
                  required: true,
                  message: 'Please input Notes',
                },*/
              ]}
            >
              <Input.TextArea />
            </Form.Item>
          </div>
          { false && creditCard && <>
            <div>
              <Table rowSelection={{
                  type: 'checkbox',
                  ...rowSelection,
                }} dataSource={data}>
                <Table.Column
                  title="Merchant"
                  dataIndex="descriptor"
                  key="descriptor"
                />
                <Table.Column
                  title="Amount"
                  dataIndex="amount"
                  key="amount"
                  render={(amount, record) => (
                    <>
                      { selectedKeys && selectedKeys.indexOf(record.key) > -1
                        ? (<><InputNumber defaultValue={record.amountInCents} min="0" max={record.amountInCents} onChange={(val) => handleAmountChange(record, val)}/> &#162;</>)
                        : <span>{amount}</span> }
                    </>
                  )}
                />
                <Table.Column
                  title="Date"
                  dataIndex="date"
                  key="date"
                />
              </Table>
            </div>
            <hr />
            <div style={{textAlign: 'center'}}>
              <label>Total Amount Due <small>(cents)</small>: </label> {accountDetails?.paymentDueInCents}&#162; &nbsp;&nbsp;&nbsp;
              <label>Amount Voided <small>(cents)</small>:</label> {voidedAmount}&#162;
            </div>
          </>
          }
          <hr />
          <div>
            <Form.Item >
              <Button type="primary" htmlType="submit" disabled={modalLoading}>
                Submit
              </Button>
              &nbsp;
              <Button htmlType="button" onClick={cancelPatch} disabled={modalLoading}>
                Cancel
              </Button>
            </Form.Item>
          </div>
        </Form>
      </Modal>
    </>
  );
}